// extracted by mini-css-extract-plugin
var _1 = "ZBMul4hIjV8OvbA0nSfW";
var _2 = "DqD45E6Op1c74qFginP0";
export { _1 as "border", _2 as "container" }
